import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class AgentHighlightsItem extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
	
	handleToggle(_el) { 
    	this.setState({ open: !this.state.open });
    	setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
  	};
  	
  	handleResize() {
	  	if (this.accordionBody && this.accordionBodyInner && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	
	render () {
		
		let item = this.props.item;
				
		if (item) {
									
			return (
				
				<>
				
					{item.text &&
						
						<div className={'c-accordion-item ' + (this.state.open ? 'state-open' : "")}>
							<div className="c-accordion-item__table-row">
								<h3 className="c-accordion-item__table-row__heading" dangerouslySetInnerHTML={{__html:item.heading}}></h3>
								<div className="c-accordion-item__clickable" onClick={this.handleToggle}></div>
								{item.button_text && item.url &&
									<>
										{item.url.indexOf('http') === -1 &&
											<Link to={{ pathname: item.url }} className="c-accordion-item__link" dangerouslySetInnerHTML={ {__html: item.button_text}}></Link>
										}
										{item.url.indexOf('http') !== -1 &&
											<a href={item.url} className="c-accordion-item__link" target="_blank" dangerouslySetInnerHTML={ {__html: item.button_text}}></a>
										}
									</>
								}
							</div>
							<div className="c-accordion-item__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
								<div className="c-accordion-item__body__inner" ref={e => (this.accordionBodyInner = e)}>
									<div className="c-accordion-item__body__content">
										<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={ {__html: item.text}}></div>
									</div>
								</div>
							</div>
							{item.srcset && 
								<div className="c-agent__table-row__image">
									<div className="c-agent__table-row__image__inner">
										<FadeIn>
											{onload => (
												<img
													alt={""} 
													src={item.src} 
													srcSet={item.srcset} 
													onLoad={onload}
												/>
											)}
										</FadeIn>
									</div>
								</div>
							}
						</div>
					
					}
					
					{!item.text &&
						
						<div className="c-accordion-item">
							<Link to={{ pathname: item.url }} className="c-accordion-item__table-row">
								<h3 className="c-accordion-item__table-row__heading" dangerouslySetInnerHTML={{__html:item.heading}}></h3>
								<p className="c-accordion-item__link" target="_blank" dangerouslySetInnerHTML={ {__html: 'View Project'}}></p>
							</Link>
							{item.srcset && 
								<div className="c-agent__table-row__image">
									<div className="c-agent__table-row__image__inner">
										<FadeIn>
											{onload => (
												<img
													alt={""} 
													src={item.src} 
													srcSet={item.srcset} 
													onLoad={onload}
												/>
											)}
										</FadeIn>
									</div>
								</div>
							}
						</div>
					
					}

				
				</>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
